import ColumnChartContainer from './ColumnChartContainer';

export default ColumnChartContainer;
